<template>
  <div class="pricing-tier-card" :class="[{ deletion: isMarkedForDeletion }]">
    <md-button :class="[ 'md-icon-button', { 'md-danger': allowDelete } ]" @click="toggleDelete">
      <md-icon :class="{ 'not-allowed': !allowDelete }">close</md-icon>
    </md-button>

    <div class="md-layout">
      <md-field class="md-layout-item md-size-40">
        <label>Min # Orders</label>
        <md-input v-model.number="tierInfo.min" type="number" min="1" step="1" />
      </md-field>

      <span id="toSpan" class="md-layout-item md-size-20">TO</span>

      <md-field class="md-layout-item md-size-40">
        <label>Max # Orders</label>
        <md-input v-model.number="tierInfo.max" type="number" min="1" step="1" />
      </md-field>
    </div>

    <div class="md-layout">
      <md-field class="md-layout-item md-size-25">
        <label>Tier</label>
        <md-input v-model.number="tierInfo.tier" type="number" min="1" step="1" />
      </md-field>
      <div class="md-layout-item md-size-5" />
      <md-field class="md-layout-item md-size-60">
        <label>Service %</label>
        <md-input v-model.number="tierInfo.percent" type="number" min="0" step="0.01" />
        <strong>%</strong>
      </md-field>
    </div>
  </div>
</template>

<script>
export default {
  name: "pricing-tier-card",
  props: {
    tierInfo: {
      type: Object,
      default: {
        tier: 1,
        min: 1,
        max: 10000,
        percent: 5.0,
        _destroy: null
      }
    },
    allowDelete: {
      type: Boolean,
      default: true
    },
  },
  computed: {
    isMarkedForDeletion() {
      return this.tierInfo["_destroy"]
    }
  },
  methods: {
    toggleDelete() {
      if (this.allowDelete) {
        this.$emit("toggleDelete", this.tierInfo)
      }
    }
  }
}
</script>

<style lang=scss>
  #toSpan {
    line-height: 60px;
    height: 60px;
  }
  .inline-field {
    display: inline-flex;
  }
  .pricing-tier-card {
    padding: 10px;
    margin: 0px 10px;
    display: inline-block;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
    -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
    border-radius: 6px;
    width: 250px;
  }
  .md-input {
    width: 100%;
  }
  .deletion {
    opacity: .9;
    background-color: #fdd;
  }
  .not-allowed {
    cursor: not-allowed;
  }
</style>
